export default __webpack_public_path__ + "static/media/logo.15704da3.svg";